module.exports = __webpack_public_path__ + "img/drive-panel-aircon-on.b74daca7.svg";